import React, { useState, useEffect } from 'react'
import Header from '../master/SideBar'
import Nav from '../master/NavBar'
import Dnf from '../Errors/Dnf';
import AccessDenied from '../Errors/AccessDenied';
import AcademicHeader from './AcademicHeader';

const Holiday = () => {
    const [loading, setLoading] = useState(false);
    const [holidays, setHolidays] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingHoliday, setEditingHoliday] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        date: '',
        description: ''
    });

    // Simulate fetching holidays (API can replace this)
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setHolidays([
              
                
            ]);
            setLoading(false);
        }, 1000);
    }, []);

    
    const handleOpenModal = (holiday = null) => {
        if (holiday) {
            setEditingHoliday(holiday);
            setFormData({
                name: holiday.name,
                date: holiday.date,
                description: holiday.description
            });
        } else {
            setEditingHoliday(null);
            setFormData({
                name: '',
                date: '',
                description: ''
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        setTimeout(() => {
            if (editingHoliday) {
                // Update existing holiday
                setHolidays((prev) =>
                    prev.map((h) =>
                        h.id === editingHoliday.id ? { ...h, ...formData } : h
                    )
                );
            } else {
                // Add new holiday
                setHolidays((prev) => [
                    ...prev,
                    { id: Date.now(), ...formData }
                ]);
            }
            setLoading(false);
            setShowModal(false);
        }, 800);
    };

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this holiday?')) {
            setHolidays(holidays.filter((h) => h.id !== id));
        }
    };

    return (
        <>
            {loading && (
                   <div
                     className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                     style={{ zIndex: 9999 }}
                   >
                     <div className="sk-chase sk-primary display-1">
                       <div className="sk-chase-dot" />
                       <div className="sk-chase-dot" />
                       <div className="sk-chase-dot" />
                       <div className="sk-chase-dot" />
                       <div className="sk-chase-dot" />
                       <div className="sk-chase-dot" />
                     </div>
                   </div>
                 )}
           
                 <div className="layout-wrapper layout-content-navbar">
                   <div className="layout-container">
                     <Header />
                     <div className="layout-page">
                       <Nav />
           
                       <div className="container-fluid mt-2">
                         <div className="row custom-scroll-layout">
                           <div className="col-md-2 left-pane">
                             <AcademicHeader data={"Academic Portal"} />
                           </div>
                           <div className="col-md-10 right-pane">
                             <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h3>Holiday List</h3>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => handleOpenModal()}
                                            >
                                                + Add Holiday
                                            </button>
                                        </div>

                                        {holidays.length === 0 ? (
                                            <Dnf message="No holidays found" />
                                            // <AccessDenied/>
                                        ) : (
                                            <table className="table table-hover text-center">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Holiday Name</th>
                                                        <th>Date</th>
                                                        <th>Description</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {holidays.map((holiday, index) => (
                                                        <tr key={holiday.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{holiday.name}</td>
                                                            <td>{holiday.date}</td>
                                                            <td>{holiday.description}</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-info me-2"
                                                                    onClick={() => handleOpenModal(holiday)}
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(holiday.id)}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {/* Modal for Add/Edit */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {editingHoliday ? 'Edit Holiday' : 'Add Holiday'}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                />
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control input-uppercase"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label >Holiday Name</label>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label >Date</label>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <div className="form-floating form-floating-outline">
                                            <textarea
                                                className="form-control input-uppercase"
                                                name="description"
                                                rows="3"
                                                value={formData.description}
                                                onChange={handleChange}
                                                required
                                            ></textarea>
                                            <label>Description</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseModal}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        {editingHoliday ? 'Update' : 'Add'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Holiday;
